module.exports = __webpack_public_path__ + "static/media/amman.f11ad4a2.jpg";